import PermanentStorage from './permanentStorage'

const VisitiorTracking = {
  getVisitorID () {
    let id = PermanentStorage.getValue('visitorTrackingId')

    if (!id) {
      id = this.uuidv4()
      PermanentStorage.setValue('visitorTrackingId', id)
    }
    return id
  },
  uuidv4 () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8) // eslint-disable-line
      return v.toString(16)
    })
  }
}

export default VisitiorTracking



// WEBPACK FOOTER //
// ./src/services/visitorTracking.js